import { Component } from '@angular/core';
import { getNestedValue } from '../../util/table-v2.utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
/**
 * @deprecated use v3 version of this component instead
 */
function FileSizeRendererComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.checkFileSize(ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey)));
  }
}
export class FileSizeRendererComponent {
  rowData;
  columnKey;
  getNestedValue = getNestedValue;
  checkFileSize(fileSize) {
    const size = parseInt(fileSize, 10);
    if (isNaN(size) || size <= 0) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    let unitIndex = 0;
    let formattedSize = size;
    while (formattedSize >= 1024 && unitIndex < units.length - 1) {
      formattedSize /= 1024;
      unitIndex++;
    }
    // Format the size with two decimal places only for units larger than bytes
    const sizeDisplay = unitIndex === 0 ? `${formattedSize}` : formattedSize.toFixed(2);
    return `${sizeDisplay} ${units[unitIndex]}`;
  }
  static ɵfac = function FileSizeRendererComponent_Factory(t) {
    return new (t || FileSizeRendererComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FileSizeRendererComponent,
    selectors: [["geaui-size-renderer"]],
    decls: 1,
    vars: 1,
    consts: [[4, "ngIf"]],
    template: function FileSizeRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, FileSizeRendererComponent_div_0_Template, 3, 1, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.rowData);
      }
    },
    dependencies: [i1.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileSizeRendererComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-size-renderer',
      template: "<div *ngIf=\"rowData\">\n  <span>{{ checkFileSize(getNestedValue(rowData, columnKey)) }}</span>\n</div>\n"
    }]
  }], null, null);
})();
